import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React, {type FC} from 'react';

import {
  createDismissibleBanner,
  DEFAULT_BANNER_SHOW_AFTER,
} from '../../../pages/Billing/AccountSettings/WarningBanner/DismissibleBanner';
import {
  AccountStatusBanner,
  AccountStatusBannerBoldText,
  AccountStatusBannerFlexWrapper,
  AccountStatusBannerTextWrapper,
} from '../../AccountStatusBanner';

// Source: https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
const CHINA_TIMEZONES = [
  'Asia/Shanghai',
  'Asia/Urumqi',
  'Asia/Chongqing',
  'Asia/Chungking',
  'Asia/Harbin',
  'Asia/Kashgar',
  'PRC',
];
const HONG_KONG_TIMEZONES = ['Asia/Hong_Kong', 'Hongkong'];
const MACAU_TIMEZONES = ['Asia/Macau', 'Asia/Macao'];
export const RESTRICTED_REGION_TIMEZONES = CHINA_TIMEZONES.concat(
  HONG_KONG_TIMEZONES,
  MACAU_TIMEZONES
);

export const RestrictedRegionBannerGlobalList: FC = () => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (!RESTRICTED_REGION_TIMEZONES.includes(timezone)) {
    return null;
  }
  return <RestrictedRegionBanner />;
};

export const RestrictedRegionBanner: FC = createDismissibleBanner<
  Record<string, never>
>({
  id: () => 'restricted-region',
  showAfter: DEFAULT_BANNER_SHOW_AFTER,
  Component: () => {
    return (
      <Tailwind>
        <AccountStatusBanner
          eventData={{
            location: `restricted region banner`,
          }}>
          <AccountStatusBannerFlexWrapper>
            <div>
              <Icon name="info" />
            </div>
            <AccountStatusBannerTextWrapper>
              <span>
                <AccountStatusBannerBoldText>
                  Notebooks and Sandboxes are no longer available in your
                  location. Access to all remaining services will end on October
                  30, 2026.
                </AccountStatusBannerBoldText>{' '}
              </span>
            </AccountStatusBannerTextWrapper>
          </AccountStatusBannerFlexWrapper>
        </AccountStatusBanner>
      </Tailwind>
    );
  },
});
